// extracted by mini-css-extract-plugin
module.exports = {"container":"error_container__4a_Mm","wrapper":"error_wrapper__5t8ND","info":"error_info__Kk6DH","btn":"error_btn__vFyDV","bear":"error_bear__Xx57J","zzz":"error_zzz__nnwaY"};